<template>
    <div class="fiance-withdraw">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">
                    <!--<el-select v-model="name_value" filterable placeholder="租客姓名">-->
                        <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-select v-model="pay_value" filterable placeholder="支付方式">-->
                        <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels-->
                                    <!--range-separator="至"-->
                                    <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2"-->
                                    <!--value-format="yyyy-MM-dd" @change="kkkk">-->
                    <!--</el-date-picker>-->
                </div>
                <div class="button-group">
                    <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels-->
                                    <!--range-separator="至"-->
                                    <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2"-->
                                    <!--value-format="yyyy-MM-dd" @change="kkkk">-->
                    <!--</el-date-picker>-->
                    <!--<el-button type="primary" icon="el-icon-search" @click="">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>
            </div>

            <div class="table-content">
                <el-table class="table-head" :data="withdrawData" border type=index style="width: 100%">
                    <el-table-column align="center" type="index" min-width="50"></el-table-column>
                    <!--<el-table-column align="center" prop="detail" label="详细" min-width="40">-->
                        <!--<template slot-scope="scope">-->
                                <!--<div slot="reference" class="name-wrapper">-->
                                    <!--<el-button size="small" type="primary" plain icon="el-icon-tickets" @click="ss"></el-button>-->
                                <!--</div>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column align="center" prop="accountname" label="提现账户名" min-width="80" sortable></el-table-column>
                    <el-table-column align="center" prop="accountid" label="提现卡号" min-width="80" sortable></el-table-column>
                    <el-table-column align="center" prop="accountbank" label="提现银行" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="money" label="提现金额(元)" min-width="80" sortable></el-table-column>
                    <!--<el-table-column prop="poundage" label="手续费"></el-table-column>-->
                    <el-table-column align="center" prop="status" label="状态" min-width="50" :filters="[{ text: '审核中', value: '审核中' },{ text: '完成提现', value: '完成提现' }, { text: '审核拒绝', value: '审核拒绝' }]"
                                     :filter-method="filterTag"
                                     filter-placement="bottom-end"></el-table-column>
                    <el-table-column align="center" prop="time" label="提现时间" min-width="100" sortable show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "FinanceWithdraw",
        data() {
            return {
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date_value: 0,
                name_value: 0,
                pay_value: 0,

                withdrawData: [],
            };
        },
        mounted: function () {
            this.withdraw();
        },
        methods: {
            withdraw() {
                this.$http.get(`${store.state.url}account?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let Data = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    let status = "";
                                    if (res.Data[i].Status == 2) {
                                        status = "审核拒绝";
                                    } else if (res.Data[i].Status == 4) {
                                        status = "完成提现";
                                    } else {
                                        status = "审核中";
                                    }

                                    Data[i] = {
                                        accountname: res.Data[i].Accountname,
                                        accountid: res.Data[i].Accountid.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, "$1 "),
                                        accountbank: res.Data[i].Accountbank,
                                        money: res.Data[i].Money.toFixed(2),
                                        // poundage: poundage,
                                        status: status,
                                        time: res.Data[i].Addtime.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, ""),
                                    };
                                }
                            }
                            this.withdrawData = Data;
                        } else {
                            this.withdrawData = [];
                            this.$message(res.Message);
                        }
                    })
            },
            filterTag(value, row) {
                return row.status === value;
            },

            //导出excel
            downloadMater (){
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.withdrawData){
                    Data[i] = {
                        提现账户名: this.withdrawData[i].accountname,
                        提现卡号: this.withdrawData[i].accountid,
                        提现银行: this.withdrawData[i].accountbank,
                        提现金额: this.withdrawData[i].money,
                        状态: this.withdrawData[i].status,
                        提现时间: this.withdrawData[i].time,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "提现记录.xls");
            },
            //字符串转字符流
            s2ab (s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },


        }

    }
</script>

<style scoped>
    .table-content {
        margin-right: 0;
    }

    .select-search {
        margin: 0 0.05rem 0.2rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

</style>
